import { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from "@progress/kendo-react-layout";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import { useTranslation } from "react-i18next";
import DavetliEtkinlikService from "../../../services/srv-davetli/DavetliEtkinlikService";
import { guestEventGridColumns } from "./GuestEventGridColumns";
import CommonGrid from "../../../components/sys-common/CommonGrid";
import { confirmAlert } from "react-confirm-alert";
import { getConfirmWarningMessage } from "../../../helpers/utils";

const GuestEventList = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const initialDataState = {
    take: 10,
    skip: 0,
    sort: [{ field: "davetlI_ETKINLIK_TANIM_ID", dir: "desc" }],
    filter: { logic: "and", filters: [] },
  };

  const [dataState, setDataState] = useState(initialDataState);
  const [data, setData] = useState(null);

  useEffect(() => {
    getData();
  }, [dataState]);

  useEffect(() => {
    if (props.isAdded) {
      getData();
      props.setIsAdded(false);
    }
  }, [props.isAdded]);

  const getData = () => {
    setLoading(true);
    DavetliEtkinlikService.getList(dataState)
      .then((res) => {
        setData(res?.data);
      })
      .finally(() => setLoading(false));
  };

  const handleEdit = (dataItem) => {
    props.setSelectedEvent(dataItem);
    props.toggleDialogUpdate();
  };

  const isActive = (dataItem) => dataItem?.aktiF_PASIF !== "PASIF";

  const handleChangeStatus = (dataItem) => {
    const nextStatus = isActive(dataItem) ? "PASIF" : "AKTIF";
    const defaultAlertMessages = {
      TittleWarning: t("warning"),
      MessageDetailWarning: isActive(dataItem)
        ? t("are_you_sure_deactivate_guest_event")
        : t("are_you_sure_activate_guest_event"),
      Yes: t("yes"),
      No: t("no"),
    };
    confirmAlert({
      customUI: ({ onClose }) => {
        return getConfirmWarningMessage(
          onClose,
          () => {
            DavetliEtkinlikService.changeStatus({
              DAVETLI_ETKINLIK_TANIM_ID: dataItem.davetlI_ETKINLIK_TANIM_ID,
              AKTIF_PASIF: nextStatus,
            }).then((res) => {
              if (!res) return;
              getData();
            });
          },
          defaultAlertMessages,
        );
      },
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("guest_events")}</CardTitle>
      </CardHeader>
      <CardBody>
        {loading ? <LoadingPanel /> : null}
        <CommonGrid
          data={data}
          dataState={dataState}
          onDataStateChange={(event) => setDataState(event.dataState)}
          columns={guestEventGridColumns}
          addButton={{
            text: t("add_guest_event"),
            onClick: props.toggleDialogAdd,
          }}
          editButton={{
            text: t("edit"),
            onClick: handleEdit,
          }}
          detailButton={{
            text: t("detail"),
            onClick: props.goDetail,
          }}
          statusButton={{
            text: (dataItem) =>
              isActive(dataItem) ? t("deactivate") : t("activate"),
            color: (dataItem) => (isActive(dataItem) ? "warning" : "success"),
            icon: (dataItem) =>
              isActive(dataItem) ? "fa fa-ban" : "fa fa-check-circle",
            onClick: handleChangeStatus,
          }}
          exportExcelProps={{
            loadingFunction: setLoading,
            serviceMethod: DavetliEtkinlikService.getForExcel,
            fileName: "DavetliEtkinlikListesi",
          }}
          dataItemKey="davetlI_ETKINLIK_TANIM_ID"
        />
      </CardBody>
    </Card>
  );
};

export default GuestEventList;
